import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/auth/Login';
// components
import LoadingScreen from '../components/LoadingScreen';
import { PermissionsProvider } from '../contexts/PermissionsContexts';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  // Guarda la ruta solicitada solo si no está autenticado y aún no la guardaste
  useEffect(() => {
    if (!isAuthenticated && !requestedLocation) {
      setRequestedLocation(pathname);
    }
    // eslint-disable-next-line
  }, [isAuthenticated, pathname]);

  // Limpia la ruta solicitada si ya navegaste a ella
  useEffect(() => {
    if (isAuthenticated && requestedLocation && pathname === requestedLocation) {
      setRequestedLocation(null);
    }
    // eslint-disable-next-line
  }, [isAuthenticated, pathname, requestedLocation]);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    return <Navigate to={requestedLocation} replace />;
  }

  return <PermissionsProvider>{children}</PermissionsProvider>;
}
